import React, { useState, useEffect } from "react";
import UniversityManagerSidebar from "./UniversityManagerSidebar";
import UniversityManagerHeader from "./UniversityManagerHeader";

const UniversityManagerLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => window.innerWidth < 1024
  );

  useEffect(() => {
    let prevWidth = window.innerWidth;
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      // Auto-collapse when crossing below the tablet/desktop threshold
      if (prevWidth >= 1024 && currentWidth < 1024) {
        setSidebarCollapsed(true);
      }
      prevWidth = currentWidth;
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`um-layout ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <UniversityManagerSidebar isCollapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      <UniversityManagerHeader sidebarCollapsed={sidebarCollapsed} />
      <main className="um-main-content">
        {children}
      </main>
    </div>
  );
};

export default UniversityManagerLayout;
